export default __webpack_public_path__ + "static/media/p1.ccaa4372.png";